import { FaArrowUp } from 'react-icons/fa';

import React, { useEffect, useState } from 'react';
import { BtnUp } from './BtnElements';

import './Btn.css';

const BtnToTop = () => {
  const [active, setActive] = useState(false);
  useEffect(() => {
    const updateVisibility = () => {
      setActive(window.pageYOffset > 300);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });

    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  const top = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <BtnUp
      type="button"
      onClick={top}
      aria-label="Scroll to the top"
      className={active ? 'btn_active' : 'btn_inactive'}
    >
      <FaArrowUp aria-hidden="true" />
    </BtnUp>
  );
};

export default BtnToTop;
